export const ADD_PREVNAME = 'ADD_PREVNAME';
export const DELETE_PREVNAME = 'DELETE_PREVNAME';
export const ADD_STUDENT_PREVNAME = 'ADD_STUDENT_PREVNAME';
export const DELETE_STUDENT_PREVNAME = 'DELETE_STUDENT_PREVNAME';